<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      v-if="handleShowMenu(item.header || item.title, profile.role)"
      :item="item"
    />
  </ul>
</template>

<script>
import { mapGetters} from 'vuex'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import VerticalNavMenuHeader from '../vertical-nav-menu-header/VerticalNavMenuHeader.vue'
import MenuReportPermission, { restrictedReportPermission } from '@/common/permission/menu/report'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      isLoaded: true,
      menuReportPermission: MenuReportPermission,
      restrictedReportPermission: restrictedReportPermission,
      handleHeader: [
        'Report',
        'Ticket Detail Report (New)',
        'Ticket Summary By Agent', 
        'Ticket Summary By Channel',
        'Ticket Summary By Case Type',
        'Detail Report'
      ],
      restrictedReportHeader: [
        'Categories',
        'Complain Report'
      ]
    }
  },
  computed: {
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      profile: 'User/user',
    })
  },
  mounted () {
  },
  methods: {
    handleShowMenu(header, role) {
      if (!header || !role) {
        return true // แสดงเมนูถ้าไม่มีข้อมูล
      }
      
      // ตรวจสอบ Categories Report และ Complain Report ก่อน (Super Admin เท่านั้น)
      if(this.restrictedReportHeader.includes(header) && !this.restrictedReportPermission.includes(role)) {
        return false
      }
      
      // ตรวจสอบ Report ทั่วไป
      if(this.handleHeader.includes(header) && !this.menuReportPermission.includes(role)) {
        return false
      }
      
      return true
    }
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
